import { useEffect } from 'react';
import Image from 'next/image';
import cn from 'classnames';
import gsap from 'gsap';

const AnimCard1 = () => {
  useEffect(() => {
    gsap.context(() => {
      gsap
        .timeline({
          repeat: -1
        })
        .fromTo(
          '.anim-card-1-globo-js',
          {
            scale: 0
          },
          {
            scale: 1,
            stagger: 0.4
          }
        )
        .to('.anim-card-1-globo-js', {
          y: 1,
          duration: 1
        });
    });
  }, []);

  return (
    <>
      <div className="absolute inset-0">
        <Image
          src="/images/animcards/1/hombres.svg"
          width={228}
          height={193}
          alt=""
          style={{ width: "100%", height: "auto" }}
          className="object-cover"
        />
      </div>
      <div className="absolute top-[4%] left-[44%] origin-bottom-left | anim-card-1-globo-js">
        <div className="aspect-[41/28]">
          <Image
            src="/images/animcards/1/globo1.svg"
            width={41}
            height={28}
            alt=""
            style={{ width: "100%", height: "auto" }}
            className="object-cover"
          />
        </div>
      </div>
      <div className="absolute top-[6%] right-[40%] origin-bottom-right | anim-card-1-globo-js">
        <div className="relative aspect-[34/23]">
          <Image
            src="/images/animcards/1/globo2.svg"
            fill
            alt=""
            className="object-cover"
          />
        </div>
      </div>
      <div className="absolute top-[10%] left-[45%] origin-bottom-left | anim-card-1-globo-js">
        <div className="aspect-[27/16]">
          <Image
            src="/images/animcards/1/globo3.svg"
            width={27}
            height={16}
            alt=""
            style={{ width: "100%", height: "auto" }}
            className="object-cover"
          />
        </div>
      </div>
      <div className="absolute top-[12%] right-[40%] origin-bottom-right |  anim-card-1-globo-js">
        <div className="aspect-[20/12]">
          <Image
            src="/images/animcards/1/globo4.svg"
            width={20}
            height={12}
            alt=""
            style={{ width: "100%", height: "auto" }}
            className="object-cover"
          />
        </div>
      </div>
    </>
  );
};
export default AnimCard1;
